import { next } from '@vercel/edge';
import type { Middleware, Props } from './types';
import { EdgeResponse } from './response';
import { EdgeRequest } from './request';

export class NextUse {
    private req: EdgeRequest;
    private readonly res: EdgeResponse;
    private readonly middlewares: Middleware[] = [];
    private readonly event: FetchEvent;
    private readonly originalURL: URL;

    constructor({ request, response = next(), event }: Props) {
        this.req = new EdgeRequest(request, request);
        this.res = EdgeResponse.from(response);
        this.event = event;

        this.originalURL = this.req.parsedUrl;
        this.req.originalUrl = this.originalURL;
    }

    public use(middleware: Middleware) {
        this.middlewares.push(middleware);

        return this;
    }

    public async run() {
        const start = Date.now();

        for (const middleware of this.middlewares) {
            const start = Date.now();
            const res = await middleware(this.req, this.res, this.event);

            console.log('Executed %s: %d ms', middleware.name, (Date.now() - start).toFixed(3));

            if (!(res instanceof Response)) continue;

            const rewrite = res.headers.get('x-middleware-rewrite');
            const isSend = res.headers.has('x-petm-middleware-send');
            const isNext = res.headers.has('x-middleware-next');

            if (isNext) continue;

            if (rewrite && !isSend) {
                this.req = new EdgeRequest(rewrite, this.req);
                this.res.headers.set('x-middleware-rewrite', rewrite);
            } else {
                res.headers.delete('x-petm-middleware-send');
                return res;
            }
        }

        const res = next({ request: this.req, headers: this.res.headers });
        console.log(
            '%s %s  %d - %d ms',
            this.req.method,
            this.originalURL.pathname,
            res.status,
            (Date.now() - start).toFixed(3)
        );

        if (res.headers.has('x-middleware-rewrite')) {
            // Prevent misinterpreting rewrite as a middleware continuation
            res.headers.delete('x-middleware-next');
        }

        return res;
    }
}
